var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IndexPresentation',{attrs:{"shop-list":_vm.shopList,"notice-list":_vm.noticeList}})}
var staticRenderFns = []

export { render, staticRenderFns }